module.exports = __webpack_public_path__ + "img/logo_samaria.d5584bb1.png";